export enum ContactTypeEnum {
  CLIENT = "CLIENT",
  NON_CLIENT = "NON_CLIENT",
}
